var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 472.6 512",
    style: {
      enableBackground: "new 0 0 472.6 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000123399110480224789880000013368895181775145645_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.6,0c-21.7,0-38.2,16.6-38.2,38.4v17.9C105.7,73,51,139.5,51,217.6v140.8L5.3,404.3c-3.4,3.4-5.3,8-5.3,12.8l0,0 c0,10,8.1,18.1,18.1,18.1c0,0,0,0,0,0h397c10,0,18.1-8.1,18.1-18.1l0,0l0,0c0-4.8-1.9-9.4-5.3-12.8l-45.7-45.9V217.6 c0-78.1-54.8-144.6-127.4-161.3V38.4C254.8,16.6,238.3,0,216.6,0z M267.6,460.8h-102c0,28.2,22.8,51,51,51S267.6,489,267.6,460.8z "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationFill);
export default __webpack_public_path__ + "static/media/NotificationFill.5fd8e529fbd07d1a071315ec3174a930.svg";
export { ForwardRef as ReactComponent };